/**
 * Indexing protection helper.
 *
 * When REACT_APP_ALLOW_INDEXING is not 'true' (default for staging/test),
 * we render <meta name="robots" content="noindex, nofollow, noarchive, nosnippet">
 * so search engines won't index ANY page of the site.
 *
 * Flip the env var to 'true' on go-live day (and redeploy) to make the site discoverable.
 */
export const INDEXING_ALLOWED =
  (process.env.REACT_APP_ALLOW_INDEXING || "false").toLowerCase() === "true";

export const ROBOTS_META_CONTENT = INDEXING_ALLOWED
  ? "index, follow"
  : "noindex, nofollow, noarchive, nosnippet";
